import { SshProviderKeys } from "../types.ts";

export const requiredProviderParameter = {
  description: "The cloud provider managing the instance",
  label: "Provider",
  type: "static",
  choices: SshProviderKeys,
  isPreselect: true,
} as const;

export const aliasParameter = {
  type: "generated",
  label: "Parent Alias",
  description:
    "A user friendly name for the parent resource (e.g. an account alias)",
  optional: true,
} as const;

export const routingRuleIdParameter = {
  type: "generated",
  label: "Routing Rule Id",
  description: "The routing rule identifier (fingerprint)",
} as const;

export const routingRuleNameParameter = {
  type: "generated",
  label: "Routing Rule Name",
  description: "The routing rule name",
  optional: true,
} as const;

export const sudoParameter = {
  type: "boolean",
  label: "Sudo",
  valueLabel: "Grant sudo access",
  optional: true,
} as const;

export const parentParameter = {
  type: "static",
  label: "Parent",
  description: "The parent resource",
  optional: true,
} as const;

export const groupNameParameter = {
  description:
    "SSH group name (this is a unique value of the SSH group tag defined for your organization)",
  label: "Group Name",
  type: "dynamic",
  optional: true,
} as const;

export const sessionDestinationParameter = {
  description: "Instance name or identifier",
  label: "Destination",
  type: "dynamic",
} as const;

export const regionParameter = {
  description: "The region in which the instance is located",
  label: "Region",
  type: "input",
  optional: true,
} as const;

export const zoneParameter = {
  type: "input",
  label: "Zone",
  optional: true,
} as const;

export const publicKeyParameter = {
  description:
    "Public key from the P0 CLI (contents of your ~/.p0/ssh/id_rsa.pub file).",
  hidden: true,
  hint: "To install the P0 CLI and generate the keypair, run npm -g install @p0security/cli and p0 ssh-keygen.",
  label: "Public Key",
  type: "input",
  optional: true,
} as const;

export const groupDestinationParameter = {
  description:
    "Instance name or identifier; selects a group based on the destination's membership",
  label: "Destination",
  type: "dynamic",
  optional: true,
} as const;
